

export const personalDataAttriubutes = [
  "firstName",
  "lastName",
  "birthDate",
  "sex",
  "birthPlace",
  "birthProvince",
  "birthCountry",
  "birthCountryId",
  "fiscalCode",
];

export interface RegistrationModel {
  personalData: {
    firstName: string;
    lastName: string;
    birthDate: string;
    sex: true;
    birthPlace: string;
    birthProvince: string;
    birthCountry: string;
    birthCountryId: string;
    fiscalCode: string;
  };
  primaryAddress: {
    street: string;
    streetNumber: string;
    zipCode: string;
    city: string;
    province: string;
    country: string;
    state: string;
    countryId: string;
  };
  secondaryAddress: {
    street: string;
    streetNumber: string;
    zipCode: string;
    city: string;
    province: string;
    country: string;
    state: string;
    countryId: string;
  };
  primaryPhone: {
    prefix: string;
    number: string;
    isMobile: true;
  };
  secondaryPhone: {
    prefix: string;
    number: string;
    isMobile: true;
  };
  contractData: {
    txtModel: string;
    codPlate: string;
  };
  registrationData: {
    email: string;
    password: string;
  };
}

export const FormeGiuridiche = [
  "A.R.L.",
  "ASSOCIAZIONE RICONOSCIUTA",
  "COMUNE",
  "COMUNE ACQUISTO CON PATTO DI RIS. DOM.",
  "COMUNE LOCATARIA",
  "CONSORZIO",
  "C.O.O.P.",
  "ENTI NON RICONOSCIUTI",
  "ENTI NON RICONOSCIUTI ACQUISTO CON PATTO DI RIS. DOM.",
  "ENTI NON RICONOSCIUTI LOCATAORI",
  "ENTI NON RICONOSCIUTI USUSFRUTTUARI",
  "ENTI RICONOSCIUTI",
  "ENTI RICONOSCIUTI ACQUISTO CON PATTO DI RIS. DOM.",
  "ENTI RICONOSCIUTI LOCATARI",
  "ENTI RICONOSCIUTI USUFRUTTUARI",
  "G.M.B.H.",
  "IMPRESA E SOCIETA' ESTERE USUSFRUTTUARIE",
  "IMPRESA E SOCIETA' ESTERE ACQUISTO CON PATTO DI RIS. DOM.",
  "IMPRESA E SOCIETA' ESTERE LOCATARIE",
  "MINISTERO",
  "L.T.D.",
  "MINISTERO ACQUISTO CON PATTO DI RIS. DOM.",
  "MINISTERO LOCATARIO",
  "S.P.A. SOCIETA' UNIPERSONALE",
  "S.S.",
  "S.S.R.L.",
  "ALTRO",
  "S.N.C. ACQUISTO CON PATTO DI RIS. DOM.",
  "S.S. ACQUISTO CON PATTO DI RIS. DOM.",
  "S.R.L. LOCATARIA",
  "S.S. USUFRUTTUARIA",
  "S.S. LOCATARIA",
  "S.R.L.S.",
  "S.R.L. USUSFRUTTUARIA",
  "S.R.L. SOCIO UNICO",
  "N.V.",
  "S.R.L. ACQUISTO CON PATTO DI RIS. DOM.",
  "S.R.L.",
  "S.P.A. LOCATARIA",
  "SOCIETA' COOP PER AZIONI LOCATARIA",
  "S.P.A. USUFRUTTUARIA",
  "S.P.A. CC",
  "S.P.A. CON UNICO AZIONISTA",
  "S.P.A.",
  "S.P.A. ACQUISTO CON PATTO DI RIS. DOM.",
  "PROVINCIA",
  "SOCIETA' ESTERE",
  "SOCIETA' COOP PER AZIONI USUSFRUTTUARIA",
  "SOCIETA' COOP A RESP. LIMITATA USUFRUTTUARIA",
  "SOCIETA' COOP PER AZIONI CON PATTO DI RIS. DOM.",
  "SOCIETA' COOP A RESP. ILLIMITATA LOCATARIA",
  "SOCIETA' COOP PER AZIONI",
  "SOCIETA' COOP A RESP. LIMITATA LOCATARIA",
  "SOCIETA' COOP A RESP. LIMITATA ACQUISTO CON PATTO DI RIS. DOM.",
  "S.N.C. USUFRUTTUARIA",
  "SOCIETA' COOP A RESP. LIMITATA",
  "SOCIETA' COOP A RESP. ILLIMITATA ACQUISTO CON PATTO DI RIS. DOM.",
  "SOCIETA' COOP A RESP. ILLIMITATA USUSFRUTTUARIA",
  "S.A.P.A. USUFRUTTUARIA",
  "S.A.S. ACQUISTO CON PATTO DI RIS. DOM.",
  "S.N.C. LOCATARIA",
  "SOCIETA' COOP A RESP. ILLIMITATA",
  "S.A.S. USUSFRUTTUARIA",
  "S.N.C.",
  "S.C.",
  "S.A.S. LOCATARIA",
  "S.A.S.",
  "PROVINCIA ACQUISTO CON PATTO DI RIS. DOM.",
  "PROVINCIA LOCATARIA",
  "S.A.",
  "S.A.P.A.",
  "S.A.P.A. LOCATARIA",
  "S.A.P.A. ACQUISTO CON PATTO DI RIS. DOM."
]
